var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header2"}},[_c('div',{attrs:{"id":"text"}},[_c('h1',[_vm._v(" Ações positivas para"),_c('br'),_c('span',[_vm._v("FLORESCER")]),_c('br'),_vm._v("empreendimentos ")])])])
}]

export { render, staticRenderFns }